export default __webpack_public_path__ + "static/media/logo couche_Plan de travail.5ce16f13.png";